'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidSunny = function IoAndroidSunny(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 12.5c-2 0-3.9 0.8-5.3 2.2s-2.2 3.3-2.2 5.3 0.8 3.9 2.2 5.3 3.3 2.2 5.3 2.2 3.9-0.8 5.3-2.2 2.2-3.3 2.2-5.3-0.8-3.9-2.2-5.3-3.3-2.2-5.3-2.2z m1.6-10v5h-3.2v-5h3.2z m10.1 3.4l2.4 2.4-3 3-2.3-2.4z m-23.4 0l2.9 3-2.3 2.4-3-3z m11.7 4.1c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10z m17.5 8.4v3.2h-5v-3.2h5z m-30 0v3.2h-5v-3.2h5z m23.6 10.4l3 2.9-2.4 2.4-3-3z m-22.2 0l2.4 2.3-3 3-2.4-2.4z m12.7 3.7v5h-3.2v-5h3.2z' })
        )
    );
};

exports.default = IoAndroidSunny;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-sunny.js
// module id = 1914
// module chunks = 0